import React from "react";
import styled, { css } from "styled-components";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { mediaQueries, style } from "../style";

export const ResourceHeaderContainer = styled.div`
  display: flex;
`;

export const ResourceHeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-grow: 1;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  align-items: center;
  width: ${style.vars.height.small};
  height: ${style.vars.height.small};
  background: ${style.colors.white};
  border: ${style.vars.borderWidth.thin} solid ${style.colors.grey.light};
  border-radius: ${style.vars.borderRadius.base};
  margin-right: ${style.vars.whitespace.regular};
`;

export const ResourceHeaderIcon: React.FC<{ icon: string }> = ({ icon }) => (
  <IconContainer>
    <Icon icon={icon} xlarge />
  </IconContainer>
);

export const ResourceHeaderName = styled(Text).attrs({ type: "h2" })`
  margin-top: 0;
  margin-bottom: ${style.vars.whitespace.small};
`;

const MetaSeparator = styled.span`
  margin-right: ${style.vars.whitespace.xsmall};
  margin-left: ${style.vars.whitespace.xsmall};
`;

type ResourceMetaProps = {
  hideOnMobile?: boolean;
};

export const ReasourceHeaderMetaContainer = styled.div<ResourceMetaProps>(
  ({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      display: none;

      ${mediaQueries.mediumMin} {
        display: block;
      }
    `
);

export const ResourceHeaderMeta: React.FC<ResourceMetaProps> = ({ children, hideOnMobile = false }) => (
  <ReasourceHeaderMetaContainer hideOnMobile={hideOnMobile}>
    {/*
     * We use Children.toArray here instead of Children.map because toArray
     * filters out null values and Children.map does not.
     */}
    {React.Children.toArray(children).map((child, index) => (
      <React.Fragment key={index}>
        {index > 0 && <MetaSeparator>/</MetaSeparator>}
        {child}
      </React.Fragment>
    ))}
  </ReasourceHeaderMetaContainer>
);

// These styles are intentionally blank. This is just a compact way to export
// a basic DOM element that can then have its styles overridden elsewhere.
export const ResourceHeaderInfo = styled.div``;
export const ResourceHeaderMetaItem = styled.span``;
